import { Subscription } from '@yandex-int/k-common';
import { TriangleRounded } from 'education-icons';
import { Button, H2, SimpleText, Text } from 'platform-components';
import {
    GRAVITIES,
    NOTIFICATION_THEMES,
    UI_KIT_HEADER_TYPOGRAPHY,
    UI_KIT_TEXT_TYPOGRAPHY,
} from 'platform-components/constants';
import { showIntlMessageNotification } from 'platform-components/src/components/notification/actions';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { useMount } from 'react-use';
import ym from 'react-yandex-metrika';

import { COMMON_NOTIFICATION_DELAY } from 'common.components/constants';
import { courseSubscriptionsActions } from 'store/subscriptions/actions';

import { SubscriptionModal } from '../__subscription-modal/overview-banner__subscription-modal';

interface Props {
    courseId: number | null;
    subscription: Subscription | null;
}

export const SubscriptionBanner = (props: Props) => {
    const { courseId, subscription } = props;
    const dispatch = useDispatch();
    const params = useParams<{ subject: string }>();
    const [shouldShowModal, showModal] = useState(false);
    const [isLoading, setLoading] = useState(false);

    useMount(() => {
        ym('reachGoal', 'subscription_banner_shown', { course_id: courseId, subject: params.subject });
    });

    const handleClickButton = () => {
        showModal(true);

        ym('reachGoal', 'subscription_banner_click', {
            course_id: courseId,
            subject: params.subject,
            slug: subscription?.slug,
        });
    };

    const confirmSubscription = () => {
        if (courseId && subscription) {
            setLoading(true);
            dispatch(
                courseSubscriptionsActions.subscribe({
                    courseId,
                    slug: subscription.slug,
                    onError: () => {
                        showModal(false);
                        setLoading(false);
                    },
                    onSuccess: () => {
                        dispatch(
                            showIntlMessageNotification({
                                closeDelay: COMMON_NOTIFICATION_DELAY,
                                gravity: GRAVITIES.BOTTOM,
                                messageId: 'courseView.overviewBanner.subscription.toast',
                                theme: NOTIFICATION_THEMES.TOAST,
                            })
                        );
                    },
                })
            );
        }

        ym('reachGoal', 'subscription_banner_approved', {
            course_id: courseId,
            subject: params.subject,
            slug: subscription?.slug,
        });
    };

    return (
        <>
            <div className="overview-banner__content">
                <div className="overview-banner__profit">
                    <div>
                        <div className="overview-banner__section-title">
                            <TriangleRounded className="overview-banner__section-title-icon" />
                            <H2
                                id="courseView.overviewBanner.subscription.title"
                                typography={UI_KIT_HEADER_TYPOGRAPHY.headlineXXSMedium}
                            />
                        </div>
                        <Text
                            id="courseView.overviewBanner.subscription.description"
                            typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphMRegular}
                        />
                    </div>
                </div>
                <Button className="overview-banner__button" onClick={handleClickButton}>
                    <SimpleText id="courseView.overviewBanner.subscription.button" />
                </Button>
            </div>
            {shouldShowModal && (
                <SubscriptionModal
                    isLoading={isLoading}
                    onClose={() => showModal(false)}
                    onSubscribe={confirmSubscription}
                    opened={shouldShowModal}
                    subscription={subscription!}
                />
            )}
        </>
    );
};
